<div class="header" [style.backgroundColor]="color || 'var(--color)'">
  <div class="d-flex w-50 justify-content-center">
    <button mat-button class="clients" [style.backgroundColor]="color ? color + ' !important' : '#05A5B7'" (click)="client.toggle($event)" [disabled]="clients.length === 1" #clientButton>
      <span class="d-flex align-items-center justify-content-evenly gap-2">
        <span [style.font-weight]="clientSelected !== null ? '400' : '600'">
          {{clientSelected !== null ? 'Cliente:' : 'Seleccionar Cliente:'}}
        </span>
        <span class="client-name">{{ nameClient }}</span>
        <mat-icon>expand_more</mat-icon>
      </span>
    </button>
    <p-popover #client styleClass="popover-header">
      <div class="panel-client" [style.backgroundColor]="color ? color + ' !important' : '#05A5B7'">
        <div class="d-flex align-items-center justify-content-between py-3 px-4 item-client" *ngFor="let client of clients">
        <span class="text-break client-name">{{client.name}}</span>
        <p-inputSwitch class="switch-custom header-switch orange" [(ngModel)]="client.select" [disabled]="clientSelected !== null && clientSelected !== client.id" (onChange)="selectClient($event.checked, client)"></p-inputSwitch>
      </div>
      </div>
    </p-popover>
  </div>
  <div class="v-line">
  </div>
  <div class="d-flex w-50 justify-content-center">
    <button mat-button class="clients" [style.backgroundColor]="color ? color : '#05A5B7'" (click)="projectPanel.toggle($event)" [disabled]="clientSelected === null || (this.clients.length === 1 && this.project.length === 1) || selectAllClient" #projectButton>
      <span class="d-flex align-items-center justify-content-evenly gap-2">
        <span [style.font-weight]="projectSelected !== null ? '400' : '600'">
          {{projectSelected !== null ? 'Proyecto:' : ' Seleccionar Proyecto:'}}
        </span>
        <span class="client-name">{{ nameProject }}</span>
        <mat-icon>expand_more</mat-icon>
      </span>
    </button>
    <p-popover #projectPanel styleClass="popover-header">
      <div class="panel-client" [style.backgroundColor]="color ? color : '#05A5B7'">
        <div class="d-flex align-items-center justify-content-between py-3 px-4 item-client" *ngFor="let p of project">
          <span class="text-break client-name">{{p.name}}</span>
          <p-inputSwitch class="switch-custom header-switch orange" [(ngModel)]="p.select" [disabled]="projectSelected !== null && projectSelected !== p.id" (onChange)="selectProject($event.checked, p)"></p-inputSwitch>
        </div>
      </div>
    </p-popover>
  </div>
  <div class="header-message" *ngIf="projectSelected === null && !selectAllClient">
    Para acceder al menú lateral, te invitamos a seleccionar primero un cliente y posteriormente elegir el proyecto correspondiente.
  </div>
</div>
